import { inject } from '@angular/core';
import { Router, UrlTree, type CanMatchFn } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/auth/services/auth.service';

export function RoleGuard(funcionalidadesPermitidas: number[]): CanMatchFn {
  return (): boolean | UrlTree => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const toastr = inject(ToastrService);

    const usuario = authService.getUser();

    if (usuario && usuario.funcionalidades.filter(x=> funcionalidadesPermitidas.includes(x)).length > 0 ) {
      return true;
    }
    toastr.warning("Você não possuí acesso a este módulo!","Atenção");
    return router.createUrlTree(['/home']);
  };
}
